<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs10>
                <v-text-field
                  label="角色名称"
                  required
                  :rules="rules.required"
                  v-model="item.name"
                />
              </v-flex>

              <v-flex xs2>
                <v-select
                  label="禁用"
                  v-model="item.disabled"
                  :items="[{value: true, text:'是'},{value: false, text:'否'}]"
                  :rules="rules.binary"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="起始页路由地址"
                  v-model="item.route"
                  required
                  :rules="rules.required"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field label="备注" v-model="item.note"/>
              </v-flex>

              <v-flex xs12>
                <v-card flat>
                  <v-card-title class="pa-0">
                    角色拥有的功能
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="过滤条件"
                      single-line
                      hide-details
                      clearable
                    />
                  </v-card-title>
                  <v-data-table
                    v-model="item.functions"
                    :headers="headers"
                    :items="funcItems"
                    :search="search"
                    select-all
                    item-key="dbid"
                    class="elevation-0"
                    hide-actions
                  >
                    <template slot="headerCell" slot-scope="props">
                      {{ props.header.text }}
                    </template>
                    <template slot="items" slot-scope="props">
                      <tr :active="props.selected" @click="props.selected = !props.selected">
                        <td>
                          <v-checkbox
                            :input-value="props.selected"
                            primary
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td>{{ props.item.identifier }}</td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.note }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/role';
  const funcUri = '/api/syst/function';

  export default {
    mixins: [mixin.edit(baseUri)],

    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          "name": null,
          "disabled": null,
          "functions": [],
          "route": null,
          "note": null
        },

        funcItems: [],
        search: '',

        pagination: {
          sortBy: 'name'
        },
        headers: [
          {
            text: '标识符',
            value: 'dbid'
          },
          {text: '名称', value: 'name'},
          {text: '备注', value: 'note'}
        ],

        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。',
            v => (v && v.length <= 50) || '长度必须小于50个字符。'
          ],
          binary: [
            v => (v === true || v === false) || '必填项。'
          ],
        }
      }
    },

    created() {
      this.axios
        .get(funcUri, {params: {limit: 65535}})
        .then(
          rsp => this.funcItems = rsp.data.items
        )
    },

    methods: {
      // mixin 保存数据前调用
      beforeSendData(data) {
        if (data.functions) {
          data.functions = data.functions.map(v => v.dbid);
        }
      },

      // mixin 加载数据后调用
      afterGetData(data) {
      },

      toggleAll() {
        if (this.item.functions.length) this.item.functions = [];
        else this.item.functions = this.funcItems.slice();
      },

      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false
        }
      }
    }
  }
</script>
<style>
  #role-func-tree {
    height: 350px
  }

  #role-func-tree .vue-treeselect__control {
    display: none;
  }

  #role-func-tree .vue-treeselect__menu {
    max-height: 320px;
    height: 320px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

</style>
